import {
  Backdrop,
  Card,
  CardContent,
  Container,
  Input,
  Paper,
  Typography
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from '@material-ui/icons/Search';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ConcealableContainer from 'src/components/ConcealableContainer';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import Fotograf from 'src/views/WorkOrder/Photo';
import { getTasksRequest } from '../../store/actions/taskActions';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  searchDF: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconDF: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputDF: {
    flexGrow: 1
  },
  searchButtonDF: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  backdropDF: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));
const Dosya = props => {
  const classes = useStyles();
  const { t } = useTranslation('file');
  const [DosyaFisNoData, setDosyaFisNoData] = useState([]);
  const SessionUser = getUser();
  var TitleApp = "Sirius CRM";
  if (SessionUser.Role === 2) {
    TitleApp = "Sirius Partner"
  }
  const [LoadingDF, setLoadingDF] = useState(false);
  const [filterFisNoDosya, setfilterFisNoDosya] = useState('');
  const FisNoDetayGetir = () => {
    setLoadingDF(true);
    axios
      .get(
        `/GetArtemisFisDetay/${SessionUser.ServiceShopId}/${SessionUser.UserId}/${filterFisNoDosya}`
      )
      .then(response => {
        const Deger = response.data;

        confirmAlert({
          message: `${Deger[0].FIS_NO}-${Deger[0].BASVURU_NEDENI}-${
            Deger[0].MUSTERI
          }${t('confirm_message')}`,
          buttons: [
            {
              label: 'Evet',
              onClick: () => setDosyaFisNoData(Deger)
            },
            {
              label: 'Hayır',
              onClick: () => {
                setDosyaFisNoData([]);
              }
            }
          ]
        });
        setLoadingDF(false);
      })
      .catch(error => {
        setLoadingDF(false);
      });
  };
  return (
    <Page className={classes.root} title={TitleApp}>
      <Container maxWidth="lg">
        <Header />
        <ConcealableContainer show>
          <Alert severity="warning">{t('alert_message')}</Alert>
        </ConcealableContainer>
        {LoadingDF ? (
          <Backdrop className={classes.backdropDF} open={LoadingDF}>
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : (
          <div />
        )}
        <Paper className={classes.searchDF} elevation={1}>
          <Input
            className={classes.searchInputDF}
            disableUnderline
            onChange={event => {
              setfilterFisNoDosya(event.target.value);
            }}
            placeholder={t('search')}
          />
          <SearchIcon
            onClick={FisNoDetayGetir}
            className={classes.searchIconB}
          />
        </Paper>
      </Container>
      <br />
      <Container>
        <Card>
          <CardContent>
            <Typography variant="h6" component="h2">
              {DosyaFisNoData.length === 1
                ? `${DosyaFisNoData[0].FIS_NO}-${
                    DosyaFisNoData[0].BASVURU_NEDENI
                  }-${DosyaFisNoData[0].MUSTERI}${t('confirm_message')}`
                : ''}
            </Typography>
          </CardContent>
        </Card>
      </Container>
      <br />
      {DosyaFisNoData.length === 1 ? (
        <Container>
          <Fotograf FisNo={DosyaFisNoData[0].FIS_NO} readonly={false} />
        </Container>
      ) : (
        ''
      )}
    </Page>
  );
};

export default connect(state => ({ tasks: state.tasks1 }), {
  getTasksRequest
})(Dosya);
